import React, { useEffect, useLayoutEffect } from 'react';
import Reducer from './AppProvider.reducer';

export function AppProvider({
  children,
  loadAuthUser,
}) {
  useLayoutEffect(() => {
    loadAuthUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadAuthUser();
    // initializeWebSocket();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return React.Children.only(children);
}

export default Reducer.connector({
})(AppProvider);